export const SENDING_REQUEST = 'COMPANYSEARCH_SENDING_REQUEST';
export const SEARCH_SUCCESS = 'COMPANYSEARCH_SEARCH_SUCCESS';
export const JOIN_REQUEST_SUCCESS = 'COMPANYSEARCH_JOIN_REQUEST_SUCCESS';
export const FAILURE = 'COMPANYSEARCH_FAILURE';
export const RESET_FORM = 'COMPANYSEARCH_RESET_FORM';